// extracted by mini-css-extract-plugin
export default {"container":"_4qvtU8"};